export function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/commonContext.js
// module id = 994
// module chunks = 0